import ConfirmationDialog from 'dialogs/ConfirmationDialog';
import { LINE_HEIGHT } from 'common/constants/sizes';
import Text from 'components/base/Text';

const SSO_CONFIRMATION_TYPES = {
  revoke: {
    dataTestId: 'revoke-token-confirmation-dialog',
    title: 'Disable SSO',
    content: 'Disabling will prevent all users single sign-on access',
    confirmText: 'Disable SSO',
    cancelText: 'Keep SSO On'
  },
  enable: {
    dataTestId: 'enable-token-confirmation-dialog',
    title: 'Enable SSO',
    content: (
      <div>
        Enabling will allow all users single sign-on access.
        <br />
        The process may take a few minutes.
      </div>
    ),
    confirmText: 'Enable SSO',
    cancelText: 'Keep SSO Off'
  }
};

export const SSOConfirmationDialog = ({
  type,
  isOpenState,
  isOpenSetState,
  onConfirm
}) => {
  const { dataTestId, title, content, confirmText, cancelText } =
    SSO_CONFIRMATION_TYPES[type] || {};
  return (
    <ConfirmationDialog
      data-testid={dataTestId}
      title={title}
      content={
        <Text size='large' lineHeight={LINE_HEIGHT.large}>
          {content}
        </Text>
      }
      confirmText={confirmText}
      cancelText={cancelText}
      isOpen={Boolean(isOpenState)}
      onCancel={() => isOpenSetState(false)}
      onConfirm={() => {
        isOpenSetState(false);
        onConfirm();
      }}
      justifyButtons='flex-end'
      cancelButtonType='outlined'
      okButtonType='contained'
    />
  );
};
